import { SvgIcon } from "@mui/material"

const StreamFinIcon = ()=>{
    return (
        <SvgIcon>
            <svg width="40" height="33" viewBox="0 0 40 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M40.0003 3.77447V23.5662C32.4594 11.9658 24.4794 10.4412 8.021 10.4412C19.7919 -1.32975 29.0627 -2.54031 40.0003 3.77447Z" fill="#6D9ABC" />
                <path d="M0.00019488 29.087L0.00019661 9.29533C7.54111 20.8957 15.5211 22.4203 31.9795 22.4204C20.2086 34.1913 10.9377 35.4018 0.00019488 29.087Z" fill="#6D9ABC" />
            </svg>
        </SvgIcon>
    )
}

export {StreamFinIcon}